export function initTagFilters() {
  const filters = document.querySelectorAll(".form-filter");
  const filterForm = document.querySelector(".filter-form");

  // separate filters outside of filter form
  const sort = document.getElementById("sort");
  const search = document.getElementById("search");

  // check filter form is on the page
  if (filterForm) {
    /**
     * Filter Post Content
     * @param {*} formData
     */

    function FilterPosts(formData) {
      // target postWrapper, this is where the filter return is going to replace content
      const postWrapper = document.querySelector(".tagWrapper");

      // add action and ajax nonce to formData
      formData.set("nonce", Ajax.nonce);

      if (sort) {
        formData.set("sort", sort.value);
      }

      if (search) {
        formData.set("s", search.value);
      }

      // collect form params
      const params = new URLSearchParams(formData);

      postWrapper.innerHTML =
        '<div class="ajaxLoader mt-4"><div class="dots"><div></div><div></div><div></div></div></div>';

      fetch(Ajax.ajaxurl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Cache-Control": "no-cache",
        },
        body: params,
      })
        .then((response) => {
          //console.log(response)
          return response.text();
        })
        .then((html) => {
          postWrapper.innerHTML = html;
          insp_set_query_vars();
        })
        .catch((err) => {
          console.log(err);
          // There was an error
          return err;
        });
    }

    filterForm.addEventListener("change", function (e) {
      let formData = new FormData(filterForm);
      FilterPosts(formData);
    });

    if (sort) {
      sort.addEventListener("change", function (e) {
        let formData = new FormData(filterForm);
        FilterPosts(formData);
      });
    }
  }

  // update pagination
  function insp_update_pagination() {
    let currentURL = document.URL;
    let pageUrl = location.protocol + "//" + location.host + location.pathname;
    pageUrl = pageUrl.slice(0, -1);
    let params = currentURL.split("?")[1];

    //console.log(pageUrl)
    //console.log(params)

    let pagination = document.querySelectorAll(".page-numbers");
    if (pagination) {
      pagination.forEach((page) => {
        let href = page.href;
        if (href) {
          let pageNum = page.href.match(/\/page\/([0-9]+)/);
          //console.log(pageNum)
          page.href = pageUrl + pageNum[0] + "?" + params;
        }
      });
    }
  }

  // update url history
  function insp_set_query_vars() {
    // get location without params
    let url = location.protocol + "//" + location.host + location.pathname;
    let params = [];

    filters.forEach((filter) => {
      // get filter data
      if (filter.checked || filter.selectedIndex) {
        //console.log(filter.name + ' - ' + filter.value)
        params.push({ [filter.name]: filter.value });
      }
    });

    if (search) {
      params.push({ ["s"]: search.value });
    }

    //console.log(params)
    let currentUrl = updateUrlParameter(url, params);
    //console.log(currentUrl)

    if (url.includes("page/")) {
      // url.replace(/page\/([0-9]+)/, '');
      let newURL = url.replace(/\/page\/([0-9]+)/, "");
      // replace original object with new replaced string
      window.history.replaceState(url, null, newURL);
      // replace now current url object with changed params
      window.history.replaceState(url, null, currentUrl);
    } else {
      window.history.replaceState(url, null, currentUrl);
    }

    insp_update_pagination();
  }

  function updateUrlParameter(uri, params) {
    //console.log(uri)
    //console.log(params)
    // remove the hash part before operating on the uri
    let i = uri.indexOf("#");
    let hash = i === -1 ? "" : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    params.forEach((param) => {
      for (const [key, value] of Object.entries(param)) {
        //console.log(key+': '+value)
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf("?") !== -1 ? "&" : "?";

        if (!value) {
          // remove key-value pair if value is empty
          uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), "");
          if (uri.slice(-1) === "?") {
            uri = uri.slice(0, -1);
          }
          // replace first occurrence of & by ? if no ? is present
          if (uri.indexOf("?") === -1) uri = uri.replace(/&/, "?");
        } else if (uri.match(re)) {
          uri = uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
          uri = uri + separator + key + "=" + value;
        }
      }
    });

    return uri + hash;
  }
}
